import { Routes } from '@angular/router';
import { HomeComponent } from './common/home/home.component';
import { LoginComponent } from './common/login/login.component';
import { RegisterComponent } from './common/register/register.component';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { ShipDashboardComponent } from './admin/ships/ship-dashboard/ship-dashboard.component';
import { ResourcesDashboardComponent } from './admin/resources/resources-dashboard/resources-dashboard.component';
import { ShipEditorComponent } from './admin/ships/ship-editor/ship-editor.component';
import { ResourcesEditorComponent } from './admin/resources/resources-editor/resources-editor.component';
import { BookingEditorComponent } from './common/booking/booking-editor/booking-editor.component';
import { BookingDashboardComponent } from './common/booking/booking-dashboard/booking-dashboard.component';
import { BookingPdfGeneratorComponent } from './common/booking/booking-pdf-generator/booking-pdf-generator.component';
import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { CsvimportComponent } from './admin/csvimport/csvimport.component';
import { ToursDashboardComponent } from './admin/tours/tours-dashboard/tours-dashboard.component';
import { ToursEditorComponent } from './admin/tours/tours-editor/tours-editor.component';
import { CruiseManagerDashboardComponent } from './admin/cruiseManager/cruise-manager-dashboard/cruise-manager-dashboard.component';
import { CruiseManagerEditorComponent } from './admin/cruiseManager/cruise-manager-editor/cruise-manager-editor.component';
import { ArchiveComponent } from './common/archive/archive.component';

export const routes: Routes = [
  { path: '', component: HomeComponent }, // Default route
  { path: 'login', component: LoginComponent },
  //  { path: 'register', component: RegisterComponent },

  // Protected routes for authenticated users
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard/:calendarWeek',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'booking',
    component: BookingDashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'booking/new',
    component: BookingEditorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'booking/pdf-gen',
    component: BookingPdfGeneratorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'booking/pdf-gen/:calendarWeek/:shipId/:bookingId',
    component: BookingPdfGeneratorComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'booking/:calendarWeek/:shipId/:bookingId',
    component: BookingEditorComponent,
    canActivate: [AuthGuard],
  },

  // Admin-only routes
  // Ships
  {
    path: 'ships',
    component: ShipDashboardComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'ships/new',
    component: ShipEditorComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'ships/:id',
    component: ShipEditorComponent,
    canActivate: [AdminGuard],
  },
  //Guides
  {
    path: 'resources',
    component: ResourcesDashboardComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'resources/new',
    component: ResourcesEditorComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'resources/:id',
    component: ResourcesEditorComponent,
    canActivate: [AdminGuard],
  },

  //Tours
  {
    path: 'tours',
    component: ToursDashboardComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'tours/new',
    component: ToursEditorComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'tours/:id',
    component: ToursEditorComponent,
    canActivate: [AdminGuard],
  },
  //Cruise Manager
  {
    path: 'cruise-manager',
    component: CruiseManagerDashboardComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'cruise-manager/new',
    component: CruiseManagerEditorComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'cruise-manager/:id',
    component: CruiseManagerEditorComponent,
    canActivate: [AdminGuard],
  },

  {
    path: 'import',
    component: CsvimportComponent,
    canActivate: [AdminGuard],
  },
  {
    path: 'archive',
    component: ArchiveComponent,
    canActivate: [AdminGuard],
  },

  { path: '**', redirectTo: '' }, // Redirect any unknown routes to Home
];
